// jQuery
import $ from "jquery";
window.$ = window.jQuery = $;

import intlTelInput from "intl-tel-input";

// Bootstrap
import "bootstrap/js/dist/button";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/tab";
import "../js/owlcarousel2-filter.min";
// owl carousel
require("owl.carousel");

// Main menu

$(document).ready(function() {
    $("input[type*='tel']").each(function() {
        $(this).attr("maxlength", "25");
        var phone = document.getElementsByName($(this).attr("name"))[0];
        if (phone) {
            intlTelInput(phone, {
                initialCountry: "auto",
                autoPlaceholder: "off",
                geoIpLookup: function(success) {
                    // Get your api-key at https://ipdata.co/
                    $.get(
                        "https://ipinfo.io",
                        function(response) {
                            success(response.country);
                        },
                        "jsonp"
                    );
                },
                utilsScript:
                    "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.3/js/utils.min.js"
            });
        }
    });

    if (document.getElementsByClassName("home-slider").length > 0) {
        const mq = window.matchMedia("(max-width: 640px)");
        // responsive img banner
        const items = document.getElementsByClassName("item");
        for (var i = 0; i < items.length; i++) {
            if ($(this).has("video")) {
                var responsiveVideo = $("#banner-video-" + i).data();
                if (responsiveVideo) {
                    if (mq.matches) {
                        $("#banner-source-" + i).attr(
                            "src",
                            responsiveVideo.responsive
                        );
                        var video = document.getElementById(
                            "banner-video-" + i
                        );
                        video.load();
                        video.play();
                    }
                }
            }
            if ($(this).has("img")) {
                var responsiveImg = $("#banner-img-" + i).data();
                if (responsiveImg) {
                    if (mq.matches) {
                        $("#banner-img-" + i).attr(
                            "src",
                            responsiveImg.responsive
                        );
                    }
                }
            }
        }
    }

    $(window).on("resize", function() {
        var win = $(this);
        if (win.width() <= 992) {
            $(document).on("click", ".nav-item.dropdown", function() {
                $(this)
                    .children("dropdown-menu")
                    .toggle();
            });
            $(document).on("click", ".sub-nav-item.dropdown", function() {
                $(this)
                    .parent("dropdown-menu")
                    .toggle();
            });
        }
    });
    if ($(window).width() <= 992) {
        $(document).on("click", ".nav-item.dropdown", function() {
            $(this)
                .children(".dropdown-menu")
                .toggle();
        });
        $(document).on("click", ".sub-nav-item.dropdown", function() {
            $(this)
                .parent(".dropdown-menu")
                .toggle();
        });
        $(document).on("click", ".sub-nav-item.dropdown", function() {
            $(this)
                .children(".sub-dropdown-menu")
                .toggle();
        });
    }

    $(document).on("click", ".nav-item.dropdown .nav-link", function() {
        window.location.replace($(this).attr("href"));
    });

    let FaqParams = window.location.search;
    const urlParams = new URLSearchParams(FaqParams);
    const faqtype = urlParams.get("types");

    $(document).on("click", ".faq-tag", function() {
        $(".faq-tag").removeClass("active");
        if (!$(this).hasClass("active")) {
            $(this).addClass("active");
        }
    });

    $("#form-filter .faq-tag").each(function() {
        if (
            $(this)
                .children("input")
                .val() == faqtype
        ) {
            $(".faq-tag").removeClass("active");
            if (!$(this).hasClass("active")) {
                $(this).addClass("active");
            }
        }
    });

    var fid = window.location.hash;
    var itemId = fid.substring(1, fid.length);
    if (window.location.hash) {
        if ($(".labos-card").hasClass(itemId)) {
            $("." + itemId + " .collapse").addClass("show");
            $("html, body").animate(
                {
                    scrollTop: $("." + itemId).offset().top - 200
                },
                800
            );
        }
    }

    if ($(".pagination").hasClass("smu-faq-pagination")) {
        var pages = "page";
        var type = "types";
        var url = window.location.href;
        if (url.indexOf("&" + pages + "=") != -1) {
            var newURL = location.href.split("&")[0];
            window.history.pushState("object", document.title, newURL);
        } else if (url.indexOf("?" + pages + "=") != -1) {
            var newURL2 = location.href.split("?")[0];
            window.history.pushState("object", document.title, newURL2);
        }

        if (url.indexOf("&" + type + "=") != -1) {
            var newURL3 = location.href.split("&")[0];
            window.history.pushState("object", document.title, newURL3);
        } else if (url.indexOf("?" + type + "=") != -1) {
            var newURL4 = location.href.split("?")[0];
            window.history.pushState("object", document.title, newURL4);
        }
        $(".smu-faq-pagination-wrapper").on(
            "click",
            ".pagination > li > a",
            function(event) {
                var page = $(this).text();
                var url_search = window.location.href;
                event.preventDefault();
                if (url_search.indexOf("&" + pages + "=") != -1) {
                    window.location.replace(url_search + "&page=" + page);
                } else {
                    window.location.replace(url_search + "?page=" + page);
                }
            }
        );
    }
    var seenbanner = {};
    if ($(".page-banner-image")) {
        $(".page-banner-image").each(function() {
            var txt = $(this).text();
            if (seenbanner[txt]) {
                $(this).remove();
            } else {
                seenbanner[txt] = true;
            }
        });
    }

    $(".page-banner-image").addClass("unset-display");

    var chart = document.getElementById("chartdiv");
    var info = document.getElementById("info_wrapper");
    if (chart) {
        chart.children[0].classList.add("chart_wrapper");
        $(document).on("click", "#info_wrapper .close_header", function() {
            info.innerHTML = "";
            info.classList.remove("active");
        });
    }

    $(document).on("click", ".modal-confirm .close", function() {
        $("#error-modal").remove();
        $("#sucess-modal").remove();
    });

    $("input[type=tel]").keypress(function(event) {
        if (event.which != 8 && isNaN(String.fromCharCode(event.which))) {
            event.preventDefault();
        }
    });

    $(".custom-form .custom-form-input").each(function() {
        if (
            $(this)
                .find("input, select")
                .prop("required")
        ) {
            $(this).addClass("required-field");
        }
        var attr = $(this)
            .find("input")
            .attr("data-required-checkbox");

        if (typeof attr !== typeof undefined && attr !== false) {
            $(this).addClass("required-field");
        }
    });

    $(".oc-dashed-borders").each(function() {
        $(this).addClass("table table-bordered");
    });
    $(".oc-alternate-rows").each(function() {
        $(this).addClass("table table-striped");
    });

    if (
        $(".right-side-menu-wrapper .right-side-items .right-side-item")
            .length < 1
    ) {
        $(".right-side-menu-wrapper").hide();
    }
    if ($(".owl-carousel-similar-programs .smu-card").length < 1) {
        $(".similar-programs").hide();
    }

    //show top banner on mouse enter

    $("#promo-banner").mouseenter(function() {
        if ($("#layout-header").hasClass("sticky-head")) {
            $(this).css("height", "130px");
        }
    });
    //hide top banner on mouse leave
    $("#promo-banner").mouseleave(function() {
        if ($("#layout-header").hasClass("sticky-head")) {
            $(this).css("height", "25px");
        }
    });
    // Home slider
    $(".home-slider").owlCarousel({
        loop: true,
        margin: 0,
        nav: false,
        transitionStyle: "scaleUp",
        dots: true,
        items: 1,
        autoplay: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: true
    });
    //student-life-carousel
    $(".student-life-carousel").owlCarousel({
        loop: true,
        nav: false,
        margin: 30,
        items: 3,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1
            },
            940: {
                items: 1
            },
            1000: {
                items: 3
            }
        }
    });

    // Events Slider (Home)
    $(".events-slider").owlCarousel({
        loop: true,
        nav: false,
        margin: 32,
        autoplay: true,
        autoplayTimeout: 2500,
        items: 2,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1
            },
            940: {
                items: 1
            },
            1000: {
                items: 2
            }
        }
    });

    // List programs page
    // toggle filter
    $(document).on("click", ".smu-show-hide-filter", function() {
        $(".smu-proram-filters-wrapper").toggle("fast");
        $(".smu-show-hide-filter span").toggle();
    });
    $("#partialProgramfilter").on("change", "input, select", function() {
        if (document.getElementById("form-filter")) {
            document.getElementById("form-filter").submit();
        }
    });
    $("#tags_filter").on("change", "input, select", function() {
        if (document.getElementById("form-filter")) {
            document.getElementById("form-filter").submit();
        }
    });
    $(document).on("click", ".event-calander-date", function() {
        if (document.getElementById("form-filter")) {
            document.getElementById("form-filter").submit();
        }
    });

    //  Filter selected on change
    $("#partialProgramfilter").on("change", "input, select", function() {
        var $form = $(this).closest("form");
        $form.request();
    });

    $("#start_datefilter").on("change", "input, select", function() {
        var $form = $(this).closest("form");

        $form.request();
    });

    // filter faqs and testimonals
    $("#program_filter").on("change", "input, select", function() {
        var $form = $(this).closest("form");
        $form.request();
    });

    $("#tags_filter").on("change", "input, select", function() {
        var $form = $(this).closest("form");
        $form.request();
    });
    $("#pagination_filter").on("change", "input, select", function() {
        var $form = $(this).closest("form");
        $form.request();
    });
    $("#event_paginate").on("change", "input, select", function() {
        var $form = $(this).closest("form");
        $form.request();
    });
    $("#blogs_pagination").on("change", "input, select", function() {
        var $form = $(this).closest("form");
        $form.request();
    });
    $("#clubs_pagination").on("change", "input, select", function() {
        var $form = $(this).closest("form");
        $form.request();
    });

    $("#tags_filter_testimonials").on("change", "input, select", function() {
        var $form = $(this).closest("form");

        $form.request();
    });
    $("#tags_filter_faq").on("change", "input, select", function() {
        var $form = $(this).closest("form");
        $form.request();
    });

    //faq filter select only one
    $('.faq-tag input[type="checkbox"]').click(function() {
        if ($(this).prop("checked") == true) {
            $(this)
                .parent()
                .addClass("filter-checked");
        } else if ($(this).prop("checked") == false) {
            $(this)
                .parent()
                .removeClass("filter-checked");
        }
    });
    $('.faq-tag input[type="checkbox"]').on("change", function() {
        $('.faq-tag input[type="checkbox"]')
            .not(this)
            .prop("checked", false)
            .parent()
            .removeClass("filter-checked");
    });

    $('.faq-pagination input[type="checkbox"]').click(function() {
        if ($(this).prop("checked") == true) {
            $(this)
                .parent()
                .addClass("filter-checked");
        } else if ($(this).prop("checked") == false) {
            $(this)
                .parent()
                .removeClass("filter-checked");
        }
    });
    $('.faq-pagination input[type="checkbox"]').on("change", function() {
        $('.faq-pagination input[type="checkbox"]')
            .not(this)
            .prop("checked", false)
            .parent()
            .removeClass("filter-checked");
    });

    //testimony filters
    $('.testimony-tag input[type="checkbox"]').click(function() {
        if ($(this).prop("checked") == true) {
            $(this)
                .parent()
                .addClass("filter-checked");
        } else if ($(this).prop("checked") == false) {
            $(this)
                .parent()
                .removeClass("filter-checked");
        }
    });
    $('.testimony-tag input[type="checkbox"]').on("change", function() {
        $('.testimony-tag input[type="checkbox"]')
            .not(this)
            .prop("checked", false)
            .parent()
            .removeClass("filter-checked");
    });

    //calander-event
    $(".event-calander-date").click(function() {
        if ($(this).prop("checked") == true) {
            $(this)
                .parent()
                .addClass("filter-checked");
        } else if ($(this).prop("checked") == false) {
            $(this)
                .parent()
                .removeClass("filter-checked");
        }
    });
    $(".event-calander-date").on("change", function() {
        $(".event-calander-date")
            .not(this)
            .prop("checked", false)
            .parent()
            .removeClass("filter-checked");
    });
    //  Eliminate duplicate
    var seen = {};
    $("option").each(function() {
        var txt = $(this).text();
        if (seen[txt]) {
            $(this).remove();
        } else {
            seen[txt] = true;
        }
    });

    //  Filter-Searchbar
    $(document).on("click", ".smu-program-search-bar-btn", function() {
        var value = $("#program-search-bar")
            .val()
            .toLowerCase();
        $(".smu-card").filter(function() {
            $(this).toggle(
                $(this)
                    .text()
                    .toLowerCase()
                    .indexOf(value) > -1
            );
        });
    });

    //  Clear Filter
    $(document).on("click", ".smu-clear-search", function() {
        var frm = document.getElementById("form-filter");
        frm.submit(); // Submit the form
        frm.reset(); // Reset all form data
        return false; // Prevent page refresh
    });

    //  Clear Filter
    $(document).on("click", ".btn-reset-form", function() {
        location.reload();
    });

    //Details program page

    //  Eliminate duplicate items
    var program_tablink = {};
    $(".detail-content-item").each(function() {
        var txt = $(this).text();
        if (program_tablink[txt]) {
            $(this).remove();
        } else {
            program_tablink[txt] = true;
        }
    });

    $(".smu-news_description").each(function() {
        $(this)
            .children("p")
            .slice(0, 2)
            .addClass("smu-webkit-box");
    });

    $(".smu-program-register-wrapper .card-body").addClass("col-md-7");
    //check if there is element content_filter
    let element = document.querySelector("#content_filter");

    if ($(".testimony_side_section")) {
        var testheight = $(".testimony_side_section").height();
    }
    window.onscroll = function() {
        if (testheight) {
            if (window.pageYOffset >= testheight - 230) {
                $(".testimony_side_section .what_they_say").addClass(
                    "scroll_bottom"
                );
            }
            if (window.pageYOffset <= testheight - 230) {
                $(".testimony_side_section .what_they_say").removeClass(
                    "scroll_bottom"
                );
            }
        }

        if ($(this).width() > 767) {
            if (element) {
                let content_filter = document.getElementById("content_filter");
                let sticky =
                    content_filter.offsetTop + $("#layout-header").height();
                scrollfunction(content_filter, sticky);
            }
        }

        let header = document.getElementById("layout-header");
        let stickyheader = header.offsetTop;
        let banner = document.getElementById("promo-banner");

        scrollheaderfunction(header, stickyheader, banner);
    };
    if ($(".owl-carousel-recent-news").length) {
        //recent news
        $(".owl-carousel-recent-news").each(function(el) {
            let countElements = $(this).children().length;
            let options = {};
            if (countElements > 1) {
                options = {
                    margin: 30,
                    nav: true,
                    loop: true,
                    touchDrag: true,
                    mouseDrag: true,
                    dots: false,
                    responsive: {
                        0: {
                            items: 1
                        },
                        600: {
                            items: 1
                        },
                        1000: {
                            items: 2
                        }
                    }
                };
            } else {
                options = {
                    margin: 30,
                    nav: false,
                    loop: false,
                    touchDrag: false,
                    mouseDrag: false,
                    dots: false,
                    items: 1
                };
            }
            $(this).owlCarousel(options);
        });
    }

    //$('.owl-carousel-recent-news')

    $(".owl-carousel-recent-news .owl-nav").appendTo("#smu-recent-news");
    $(".home-testimonials .professors-slider .owl-nav").appendTo(
        ".owl-stage-outer"
    );

    //similar program Carousel

    if ($(".owl-carousel-similar-programs").length) {
        //recent news
        $(".owl-carousel-similar-programs").each(function(el) {
            let countElements = $(this).children().length;
            let options = {};
            if (countElements > 1) {
                options = {
                    margin: 60,
                    nav: true,
                    loop: true,
                    dots: false,
                    responsive: {
                        0: {
                            items: 1
                        },
                        600: {
                            items: 1
                        },
                        1000: {
                            items: 2
                        }
                    }
                };
            } else {
                options = {
                    margin: 60,
                    nav: false,
                    loop: false,
                    touchDrag: false,
                    mouseDrag: false,
                    dots: false,
                    items: 1
                };
            }
            $(this).owlCarousel(options);
        });
    }

    if ($(".events-slider").length) {
        //recent news
        $(".events-slider").each(function(el) {
            let countElements = $(this).children().length;
            let options = {};
            if (countElements > 1) {
                options = {
                    loop: true,
                    nav: false,
                    margin: 32,
                    items: 2
                };
            } else {
                options = {
                    nav: false,
                    loop: false,
                    touchDrag: false,
                    mouseDrag: false,
                    dots: false,
                    items: 1
                };
            }
            $(this).owlCarousel(options);
        });
    }

    var sync1 = $("#professorsSlider");
    var sync2 = $("#professorsInfoSlider");
    var syncedSecondary = true;
    sync1
        .on("initialized.owl.carousel", function(e) {
            var idx = e.item.index;
            $(".professors-slider .owl-item")
                .eq(idx)
                .addClass("large");
            $(".professors-slider .owl-item")
                .eq(idx - 1)
                .addClass("medium");
            $(".professors-slider .owl-item")
                .eq(idx + 1)
                .addClass("medium");
        })
        .owlCarousel({
            center: true,
            items: 5,
            slideSpeed: 10000,
            autoplayHoverPause: true,
            nav: true,
            dots: false,
            loop: false,
            rewind: true,
            autoplay: true,
            responsiveRefreshRate: 200,
            responsiveClass: true,
            responsive: {
                200: {
                    items: 1
                },
                300: {
                    items: 1
                },
                400: {
                    items: 1
                },
                500: {
                    items: 2
                },
                700: {
                    items: 3
                },
                940: {
                    items: 4
                },
                1000: {
                    items: 5
                }
            }
        })
        .on("changed.owl.carousel", syncPosition);
    sync1.on("translate.owl.carousel", function(e) {
        var idx = e.item.index;
        $(".professors-slider .owl-item.large").removeClass("large");
        $(".professors-slider .owl-item.medium").removeClass("medium");

        $(".professors-slider .owl-item")
            .eq(idx)
            .addClass("large");
        $(".professors-slider .owl-item")
            .eq(idx - 1)
            .addClass("medium");
        $(".professors-slider .owl-item")
            .eq(idx + 1)
            .addClass("medium");
    });
    sync2
        .on("initialized.owl.carousel", function() {
            sync2
                .find(".owl-item")
                .eq(0)
                .addClass("current");
        })
        .owlCarousel({
            items: 1,
            dots: false,
            nav: false,
            autoplayHoverPause: true,
            mouseDrag: false,
            touchDrag: false,
            smartSpeed: 200,
            slideSpeed: 500,
            slideBy: 1,
            responsiveRefreshRate: 100
        })
        .on("changed.owl.carousel", syncPosition2);
    // sync1.on('changed.owl.carousel', function (event) {
    //     var idx = event.item.index;
    //     sync2.trigger('to.owl.carousel', [idx == 0 ? 0 : 1]);
    // });

    function syncPosition(el) {
        //if you set loop to false, you have to restore this next line
        var current = el.item.index;

        //if you disable loop you have to comment this block
        //   var count = el.item.count ;
        //
        //   var current = Math.round(el.item.index - count - 2);
        //
        //   if (current < 0) {
        //       current = count;
        //   }
        //   if (current > count) {
        //       current = 0;
        //   }

        //end block

        sync2
            .find(".owl-item")
            .removeClass("current")
            .eq(current)
            .addClass("current");
        var onscreen = sync2.find(".owl-item.active").length - 1;
        var start = sync2
            .find(".owl-item.active")
            .first()
            .index();
        var end = sync2
            .find(".owl-item.active")
            .last()
            .index();

        if (current > end) {
            sync2.data("owl.carousel").to(current, 100, true);
        }
        if (current < start) {
            sync2.data("owl.carousel").to(current - onscreen, 100, true);
        }
    }

    function syncPosition2(el) {
        if (syncedSecondary) {
            var number = el.item.index;
            // sync1.data('owl.carousel').to(number, 100, true);
        }
    }

    sync1.on("click", ".owl-item", function(e) {
        e.preventDefault();
        var number = $(this).index();
        console.log(number);
        sync1.data("owl.carousel").to(number, 300, true);
    });

    let first_tag = document.getElementById("first-tag");
    if (first_tag) {
        sync1.owlcarousel2_filter($("#first-tag").data("owl-filter"));
        sync2.owlcarousel2_filter($("#first-tag").data("owl-filter"));
    }

    $(".owl-filter-bar").on("click", ".item", function() {
        var $item = $(this);
        var filter = $item.data("owl-filter");
        $(".testimony-tag").each(function() {
            if ($(this).hasClass("filter-checked")) {
                $(this).removeClass("filter-checked");
            }
        });
        $(this).addClass("filter-checked");
        sync1.owlcarousel2_filter(filter);
        sync2.owlcarousel2_filter(filter);
    });

    //toggle footer form
    $(".footer-plus").click(function() {
        $(this)
            .parent()
            .parent()
            .toggleClass("show-footer");
    });

    //show-hide side menu
    $("#show-hide-side-menu").click(function() {
        $("#show-hide-side-menu").hide("fast");
        $(".right-side-overlay").addClass("active");
        $(".second-wrapper").show("fast");
    });
    $("#side-menu-show-hide").click(function() {
        $("#show-hide-side-menu").show("fast");
        $(".right-side-overlay").removeClass("active");
        $(".second-wrapper").hide("fast");
    });
    let page_banner = document.querySelector("#page_banner");

    // $("#layout-content").css("min-height", $(window).height()-$('#newsletter').height()-$('#layout-header').height()+"px");

    $(".student_informations:first-child").addClass("active");
    $(".student_informations").each(function() {
        $(this).click(function() {
            if ($(".student_informations").hasClass("active")) {
                $(".student_informations").removeClass("active");
                $(".student_informations").addClass("not_active");
            }
            $(this).addClass("active");
            $(this).removeClass("not_active");
        });
    });
    // FAQ page
    var faq_tag = {};
    $(".faq-tag").each(function() {
        var txt = $(this).text();
        if (faq_tag[txt]) {
            $(this).remove();
        } else {
            faq_tag[txt] = true;
        }
    });
    $(".faq-tag").each(function() {
        if (
            $(this)
                .children("span")
                .text().length == 0
        ) {
            $(this).remove();
        }
    });

    // Testimonials page
    var Testimonials_tag = {};
    $(".testimony-tag").each(function() {
        var txt = $(this).text();
        if (Testimonials_tag[txt]) {
            $(this).remove();
        } else {
            Testimonials_tag[txt] = true;
        }
        if (
            $(this)
                .children('input[type="checkbox"]')
                .val() < 1
        ) {
            $(this).remove();
        }
    });

    // $( ".home-partners .item.active" ).mouseenter(function() {
    //     $( ".home-partners .item" ).animate({opacity: 1}, 500);
    // });
    // $( ".home-partners .item.active" ).mouseleave(function() {
    //     $( ".home-partners .item" ).animate({opacity: 0}, 500);
    // });

    $(".home-gallery-slider").owlCarousel({
        loop: true,
        margin: 30,
        nav: false,
        dots: true,
        transitionStyle: "scaleUp",
        autoplay: true,
        autoplayTimeout: 2500,
        stagePadding: 0,
        singleItem: true,
        lideSpeed: 300,
        paginationSpeed: 400,
        items: 1
    });

    $(".partners-slider").owlCarousel({
        loop: true,
        margin: 30,
        responsiveClass: true,
        dots: false,
        nav: false,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 3
            },
            1000: {
                items: 5,
                nav: true,
                loop: false
            }
        }
    });

    $(".partners-col-slider").owlCarousel({
        items: 3,
        loop: true,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        margin: 0,
        autoplay: true,
        slideTransition: "linear",
        autoplaySpeed: 6000,
        autoplayHoverPause: true
    });

    $(".close-btn").click(function() {
        $("#promo-banner").slideUp();
    });

    $(".navbar-toggler").on("click", function(e) {
        if (!$(".menu-wrapper").hasClass("menu-show")) {
            $(".top-header")
                .clone()
                .appendTo(".main-menu .container-xl")
                .addClass("cloned-menu");
            $("#main-menu")
                .parent()
                .css({ height: $(window).height() + "px" });
        } else {
            $(".main-menu .container-xl .top-header").remove();
            $("#main-menu")
                .parent()
                .css({ height: "unset" });
        }
        $(".menu-wrapper").toggleClass("menu-show");
        $(".call-to-action").toggleClass("d-none");
        $(".right-side-menu-wrapper").toggleClass("d-none");

        e.preventDefault();
    });
    if ($("#program_type_url").html()) {
        $("#program_type_url").attr("href", function(i, url) {
            var str = url.substr(url.lastIndexOf("/") + 1) + "$";
            return url.replace(new RegExp(str), "");
        });
    }

    $("header .nav-item  a").each(function() {
        let url = $(this).attr("href");
        let url_http = url;
        var domain = window.location.pathname.split("/");
        var domain2 = url_http.split("/");

        if (domain2.length == 4) {
            if (domain2[domain2.length - 2] == domain[domain.length - 2]) {
                $(this)
                    .parent()
                    .parent()
                    .parent()
                    .addClass("active");
            } else if (
                domain2[domain2.length - 2] == domain[domain.length - 3]
            ) {
                $(this)
                    .parent()
                    .parent()
                    .parent()
                    .addClass("active");
            }
        }
        if (url_http == window.location.pathname) {
            $(this)
                .parent()
                .addClass("active");
        }
    });

    $(".nav-item").each(function() {
        if ($(this).hasClass("active")) {
            $(".page-banner .page-title").text(
                $(this)
                    .children("a")
                    .text()
            );
        } else {
            if ($(".breadcrumb #bcLast").text().length > 1) {
                $(".page-banner .page-title").text(
                    $(".breadcrumb #bcLast").text()
                );
            }
        }
    });

    $(".top-menu li a").each(function() {
        let url = $(this).attr("href");
        let url_http = url;

        var domain = window.location.pathname.split("/");
        var domain2 = url_http.split("/");
        if (domain2.length == 4) {
            if (domain2[domain2.length - 2] == domain[domain.length - 2]) {
                $(this)
                    .parent()
                    .addClass("active");
            }
        }
        if (domain2.length == 3 && domain.length == 4) {
            if (domain2[domain2.length - 1] == domain[domain.length - 2]) {
                $(this)
                    .parent()
                    .addClass("active");
            }
        }
        if (url_http == window.location.pathname) {
            $(this)
                .parent()
                .addClass("active");
        }
    });
    //console.log('Menu manager');
    $(".side-bar-menu-item  a").each(function() {
        let currentPathname = window.location.pathname.split("/");
        if (currentPathname.length > 3) {
            let url = $(this).attr("href");
            let url_http = url;
            var data = window.location.pathname.split("/");
            var data2 = url_http.split("/");

            if (url_http == window.location.pathname) {
                $(this)
                    .parent()
                    .addClass("active");
            }
            if (data2[data2.length - 1] == data[data.length - 2]) {
                $(this)
                    .parent()
                    .addClass("active");
            }
        }
    });

    $(".dropdown-item").each(function() {
        let url = $(this).attr("href");
        let url_http = url;
        var data = window.location.pathname.split("/");
        var data2 = url_http.split("/");
        //console.log(data);

        if (data.length > 3) {
            if (url_http == window.location.pathname) {
                $(this).addClass("active");
            }
            if (data2[data2.length - 1] == data[data.length - 2]) {
                $(this).addClass("active");
            }
        }
    });

    $(".side-bar-menu-item").each(function() {
        if ($(this).hasClass("active")) {
            $(".page-banner .page-title").text(
                $(this)
                    .children("a")
                    .text()
            );
        }
    });

    if ($("#smu-program-detail-title").text().length > 1) {
        $(".page-banner .page-title").text(
            $("#smu-program-detail-title").text()
        );
    }
    if ($(".information-int.faculty-name").text().length > 1) {
        $(".page-banner .page-title").text(
            $(".information-int.faculty-name").text()
        );
    }

    $(".top-menu li a").each(function() {
        let url = $(this).attr("href");
        let url_http = url;

        if (url_http == window.location.pathname) {
            $(this)
                .parent()
                .addClass("active");
        }
    });

    var seentitles = {};
    $(".page-banner .page-title").each(function() {
        var txt = $(this).text();
        if (seentitles[txt]) {
            $(this).remove();
        } else {
            seentitles[txt] = true;
        }
    });

    if ($(".home-slider .item").length < 1) {
        $(".target-menu .block").addClass("m-0");
        $(".home-certificats")
            .css("height", "unset")
            .css("padding-top", ".5rem")
            .css("padding-bottom", "1rem");
    }
    if ($(".smu-side-bar-menu .side-bar-menu-item").length < 1) {
        $(".smu-side-bar-menu").remove();
        $(".smu-program-wrapper").removeClass("col-lg-9");
        $("#smu_empty_page").removeClass("container");
        $(".smu_bread_crumbs").addClass("container-md");
        $(".smu-program-wrapper").addClass("col-lg-12");
    } else {
        if ($(".smu-side-bar-menu .side-bar-menu-item.active a").length < 1) {
            let loc = $(".smu-side-bar-menu .side-bar-menu-item:first a").attr(
                "href"
            );

            //alert(loc , location.href)
            if (loc != location.href) {
                //alert($(".smu-side-bar-menu .side-bar-menu-item:first a").attr('href'))
                location.replace(
                    $(".smu-side-bar-menu .side-bar-menu-item:first a").attr(
                        "href"
                    )
                );
            }
        }
    }

    $("#promo-banner").mouseenter(function() {
        if ($("#layout-header").hasClass("sticky-head")) {
            $(this).css("height", "130px");
        }
    });

    //testimony carousel

    // $('.faculty-slider').owlCarousel({
    //     loop:false,
    //     center:true,
    //     margin:10,
    //     nav:true,
    //     dots:true,
    //     items:1,
    // })

    //clubs carousel

    $(".owl-carousel-clubs").owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        autoplay: true,
        autoplayTimeout: 2000,
        autoplayHoverPause: true,
        dots: false,
        items: 1
    });

    //download document with From:
    $(".btn-reset-form").on("click", function(e) {
        e.preventDefault();
        $(".document-form-wrapperr").show();
        $(".document-form-container").hide();
    });

    $("body").on("click", ".item", function() {
        console.log($(this));
        let overlay = $(this).find(".overlay");
        console.log($(this), overlay);
        if (overlay.length > 0) {
            let link = $(this).find(".position-relative a");
            link = $(link).attr("href");
            console.log(link);
            window.location.replace(link);
        }
    })(function(e) {
        // Array of the buttons.
        var showButtons = document.getElementsByClassName(
            "document-form-wrapper"
        );
        // Event handler
        var i,
            len = showButtons.length;
        for (i = 0; i < len; ++i) {
            (function(index) {
                showButtons[i].onclick = function(e) {
                    e.preventDefault();
                    $(".document-form-wrapper").hide();
                    $("#document-form-" + index).show();
                };
            })(i);
        }
    })();

    var url_string = window.location.href;
    var url = new URL(url_string);
    var sites_map_filter = url.searchParams.get("sites_map_filter");

    if (sites_map_filter) {
        $("input[name*='sites_map_filter']").each(function() {
            if ($(this).val() != sites_map_filter) {
                $(this)
                    .parent()
                    .addClass("not-active");
            }
        });
    }
    var container_div = document.getElementById("form-filter");
    if (container_div) {
        var count = container_div.getElementsByTagName("label").length;
        if (count == 1) {
            $(".maps_site_filter_img_wrapper")
                .parent()
                .remove();
        }
    }

    var pagify = {
        items: {},
        container: null,
        totalPages: 1,
        perPage: 5,
        currentPage: 0,
        createNavigation: function() {
            this.totalPages = Math.ceil(this.items.length / this.perPage);

            $(".pagination", this.container.parent()).remove();
            var pagination = $(
                '<ul class="pagination justify-content-end mt-5 w-100"></ul>'
            ).append(
                ' <li class="smu-pagination-item"><a class="smu-pagination-item-button nav prev disabled" data-next="false"><</a></li>'
            );

            for (var i = 0; i < this.totalPages; i++) {
                var pageElClass = "page";
                if (!i) {
                    pageElClass = "page current";
                }
                var pageEl =
                    '<li class="smu-pagination-item"><a class="' +
                    pageElClass +
                    '" data-page="' +
                    (i + 1) +
                    '">' +
                    (i + 1) +
                    "</a></li>";
                pagination.append(pageEl);
            }
            pagination.append(
                '<li class="smu-pagination-item"><a class=" smu-pagination-item-button nav next" data-next="true">></a></li>'
            );

            this.container.after(pagination);

            var that = this;
            $("body").off("click", ".nav");
            this.navigator = $("body").on("click", ".nav", function() {
                var el = $(this);
                that.navigate(el.data("next"));
            });

            $("body").off("click", ".page");
            this.pageNavigator = $("body").on("click", ".page", function() {
                var el = $(this);
                that.goToPage(el.data("page"));
            });
        },
        navigate: function(next) {
            // default perPage to 5
            if (isNaN(next) || next === undefined) {
                next = true;
            }
            $(".pagination .nav").removeClass("disabled");
            if (next) {
                this.currentPage++;
                if (this.currentPage > this.totalPages - 1) {
                    this.currentPage = this.totalPages - 1;
                }
                if (this.currentPage == this.totalPages - 1) {
                    $(".pagination .nav.next").addClass("disabled");
                }
            } else {
                this.currentPage--;
                if (this.currentPage < 0) {
                    this.currentPage = 0;
                }
                if (this.currentPage == 0) {
                    $(".pagination .nav.prev").addClass("disabled");
                }
            }

            this.showItems();
        },
        updateNavigation: function() {
            var pages = $(".pagination .page");
            pages.removeClass("active");
            $(
                '.pagination .page[data-page="' + (this.currentPage + 1) + '"]'
            ).addClass("active");
        },
        goToPage: function(page) {
            this.currentPage = page - 1;

            $(".pagination .nav").removeClass("disabled");
            if (this.currentPage == this.totalPages - 1) {
                $(".pagination .nav.next").addClass("disabled");
            }

            if (this.currentPage == 0) {
                $(".pagination .nav.prev").addClass("disabled");
            }
            this.showItems();
        },
        showItems: function() {
            this.items.hide();
            var base = this.perPage * this.currentPage;
            this.items.slice(base, base + this.perPage).show();

            this.updateNavigation();
        },
        init: function(container, items, perPage) {
            this.container = container;
            this.currentPage = 0;
            this.totalPages = 1;
            this.perPage = perPage;
            this.items = items;
            this.createNavigation();
            this.showItems();
        }
    };

    // stuff it all into a jQuery method!
    $.fn.pagify = function(perPage, itemSelector) {
        var el = $(this);
        var items = $(itemSelector, el);

        // default perPage to 5
        if (isNaN(perPage) || perPage === undefined) {
            perPage = 3;
        }

        // don't fire if fewer items than perPage
        if (items.length <= perPage) {
            return true;
        }

        pagify.init(el, items, perPage);
    };

    $(".faculty_page_builder").pagify(16, ".faculty-card");

    $("#smu-cards-wrapper").pagify(9, ".smu-card");

    //$(".testimony_page_builder").pagify(10, ".testimony-card");

    $("#blogs_container .actuality-list-wrapper").pagify(9, ".actuality-card");
});

// Scroll function and make item sticky
function scrollfunction(content_filter, sticky) {
    if (window.pageYOffset >= sticky) {
        content_filter.classList.add("sticky");
        content_filter.style.top = $("#layout-header").height() + "px";
    } else {
        content_filter.classList.remove("sticky");
    }
}

// Scroll function and make header sticky
function scrollheaderfunction(content_filter, sticky, banner) {
    if (window.pageYOffset > sticky) {
        content_filter.classList.add("sticky-head");
        $("#layout-content").css(
            "padding-top",
            $("#layout-header").height() + "px"
        );
        $(".dotted_background").addClass("smu_dotted_bg");
        if (banner) {
            banner.setAttribute("style", "height:25px");
        }
        if ($("#layout-header").hasClass("sticky-head")) {
            // $(".call-to-action").css("transform","translateY(-8rem)");
            $(".right-side-menu-wrapper").css("transform", "translateY(-5rem)");
        } else {
            // $(".call-to-action").css("transform","translateY(0)");
            $(".right-side-menu-wrapper").css("transform", "translateY(0)");
        }
    } else {
        content_filter.classList.remove("sticky-head");
        $("#layout-content").css("padding-top", "0px");
        if (banner) {
            banner.setAttribute("style", "height:130px");
        }
        if ($("#layout-header").hasClass("sticky-head")) {
            // $(".call-to-action").css("transform","translateY(-7rem)");
            $(".right-side-menu-wrapper").css("transform", "translateY(-5rem)");
        } else {
            // $(".call-to-action").css("transform","translateY(0)");
            $(".right-side-menu-wrapper").css("transform", "translateY(0)");
        }
    }
}

$(window).scroll(function() {
    $(".home-section .tt-item .content").each(function() {
        var scrollTop = $(window).scrollTop(),
            elementOffset = $(this).offset().top,
            distance = elementOffset - scrollTop,
            windowHeight = $(window).height(),
            breakPoint = windowHeight * 0.9;

        if (distance > breakPoint) {
            $(this).addClass("more-padding");
            $(this)
                .parents(".tt-item:nth-child(even)")
                .children(".content")
                .addClass("less-padding");
        }
        if (distance < breakPoint) {
            $(this).removeClass("more-padding");
            $(this)
                .parents(".tt-item:nth-child(even)")
                .children(".content")
                .removeClass("less-padding");
        }
    });
});

function filterTestimonials(c) {
    var x, i;
    x = document.getElementsByClassName("testimony-card");
    for (i = 0; i < x.length; i++) {
        x[i].classList.remove("show");
    }
    var cards = document.getElementsByClassName("testimony_" + c);
    for (i = 0; i < cards.length; i++) {
        cards[i].classList.add("show");
    }
    var btns = document.getElementsByClassName("faq-tag");
    for (var i = 0; i < btns.length; i++) {
        if (btns[i].classList.contains("active")) {
        } else {
            btns[0].className += " active";
        }
    }
}
